import EfScrollAni from '@/efscrollani';
import { useLang } from '@/i18n';
import A from '../../comps/A';
import B from '../../comps/B';
import C from '../../comps/C';
import D from '../../comps/D';
import E from '../../comps/E';
import F from '../../comps/F';
import G from '../../comps/G';
import H from '../../comps/H';
import I from '../../comps/I';
import J from '../../comps/J';
import K from '../../comps/K';
import L from '../../comps/L';
import M from '../../comps/M';
import N from '../../comps/N';
import O from '../../comps/O';
import P from '../../comps/P';
import PageNavLeft from '../../comps/PageNavLeft';
import Q from '../../comps/Q';
import Calculator from '../../comps/Calculator';
import Portable from '../../comps/Portable';
import SectionCard from '../../comps/SectionCard';
import css from './index.module.scss';

const Overview: React.FC<{ callbackCart: (item: any) => void }> = ({ callbackCart }) => {
    const { t } = useLang('d3u.navList');
    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }

    return (
        <div className={`overview ${css.page}`}>
            <A />
            <B />
            <SectionCard callbackCart={callbackCart} />
            <div className="range1">
                <C />
                <Calculator />
                <D />
                <Portable />

                <E />
                <F />
            </div>
            <div className="range2">
                <G />
                <H />
            </div>
            <div className="range3">
                <I />
                <J />
                <K />
            </div>

            <div className="range4">
                <L />
                <M />
            </div>
            <div className="range5">
                <N />
            </div>
            <div className="range6">
                <O />
            </div>

            <P />
            <Q />
            <PageNavLeft
                triggerElement=".delta-3-ultra-series"
                enterElement="#D3U-C"
                steps={[
                    { text: t('item2'), href: '#D3U-C' },
                    { text: t('item4'), href: '#D3U-G' },
                    { text: t('item5'), href: '#D3U-I' },
                    { text: t('item8'), href: '#D3U-L' },
                    { text: t('item10'), href: '#D3U-N' },
                    { text: t('item11'), href: '#D3U-O' },
                ]}
            />
        </div>
    );
};

export default Overview;
